import { connect } from 'react-redux'

import { RootState } from '../../../store'
import { getAppLoading } from '../../../selectors/app'
import { get } from 'lodash'

/**
 * Import
 * - Components
 */

import Search from '../../../components/pages/Search/Search'

/**
 * Import
 * - Actions
 */
import { fetchSearch, bindQuoteVariation, confirmEditQuote } from '../../../actions'

const mapStateToProps = (state: RootState) => {
    return {
        loading: getAppLoading(state),
        searchResult: state.search,
        quotesList: get(state, 'search.response.quotes', []),
        policiesList: get(state, 'search.response.policies', []),
        step05: state.quote.step05,
    }
}
export default connect(mapStateToProps, {
    fetchSearch: fetchSearch,
    bindQuoteVariation: bindQuoteVariation,
    confirmEditQuote,
})(Search)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Search/Search.tsx